import { render, staticRenderFns } from "./ThankYou.vue?vue&type=template&id=a8999f06"
import script from "./ThankYou.vue?vue&type=script&lang=js"
export * from "./ThankYou.vue?vue&type=script&lang=js"
import style0 from "../assets/scss/components/ThankYou.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports